import { render, staticRenderFns } from "./page-section.vue?vue&type=template&id=05b07786&scoped=true&"
import script from "./page-section.vue?vue&type=script&lang=js&"
export * from "./page-section.vue?vue&type=script&lang=js&"
import style0 from "./page-section.vue?vue&type=style&index=0&id=05b07786&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b07786",
  null
  
)

export default component.exports